import type { Email } from "../../utils/interfaces";
import {
  extractEmailAddress,
  type ReplySelfContext,
} from "../../utils/replyRecipients";

export function isOutgoingEmail(
  message: Email,
  selfContext: ReplySelfContext,
): boolean {
  const sender = extractEmailAddress(message.from_email);
  if (selfContext.mailboxEmail?.trim()) {
    return (
      sender.toLowerCase() ===
      extractEmailAddress(selfContext.mailboxEmail).toLowerCase()
    );
  }
  if (selfContext.loginEmail?.trim()) {
    return (
      sender.toLowerCase() ===
      extractEmailAddress(selfContext.loginEmail).toLowerCase()
    );
  }
  return false;
}
